export enum PATGeneratorsTabs {
  DESCRIPTION = 'Description',
  FAQ = 'FAQ',
}
